"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compactHeaders = exports.BD4_USER_ID_KEY = exports.LANGUAGE_COOKIE_KEY = exports.PARTNER_REFERENCE = exports.B2B_MARKUP_KEY = exports.AGENCY_KEY = exports.PARTNER_KEY = exports.REQUEST_CONTEXT_PAGE_PROP = void 0;
exports.REQUEST_CONTEXT_PAGE_PROP = '_rct';
exports.PARTNER_KEY = 'partner';
exports.AGENCY_KEY = 'agency';
exports.B2B_MARKUP_KEY = 'b2bMarkup';
exports.PARTNER_REFERENCE = 'partner_reference';
exports.LANGUAGE_COOKIE_KEY = 'NEXT_LOCALE';
exports.BD4_USER_ID_KEY = 'bd4ti';
const ALLOWED_KEYS = [
    `agency`,
    `b2bMarkup`,
    `bd4TravelUserId`,
    `device`,
    `language`,
    `partner`,
];
const isNotValid = value => {
    return (
    // most used is undefined, so let it be first
    value === undefined ||
        value === null ||
        (typeof value === 'number' && isNaN(value)));
};
const compactHeaders = (ctx) => {
    let cleaned = false;
    const result = ALLOWED_KEYS.reduce((acc, key) => {
        if (!isNotValid(ctx[key]))
            acc[key] = ctx[key];
        else
            cleaned = true;
        return acc;
    }, {});
    // return object with same link if nothing is done to avoid re-renders
    return (cleaned ? result : ctx);
};
exports.compactHeaders = compactHeaders;
//# sourceMappingURL=request-util.utils.js.map